<div class="toggle {collapsed ? 'collapsed' : ''}">
  <ui-icon icon="sidebar" fitted class="underlay" part="underlay"></ui-icon>
  <div class="overlay" part="overlay">
    <ui-icon icon="{collapsed ? showIcon : collapseIcon }"></ui-icon>
  </div>
</div>
